module.exports = __webpack_public_path__ + "img/NUTSHELL.de035308.png";